import PensionCompany from '../model/pensionCompany'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchPensionCompanies(): Promise<RequestResponse<PensionCompany[]>> {
  return secureRequest('GET', url('/v2/pensionCompanies'))
}
